import React, { useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "./contexts/LanguageContext";
import Header from "./components/Header";
import Hero from "./components/Hero";
import Stats from "./components/Stats";
import Benefits from "./components/Benefits";
import ProblemSolution from "./components/ProblemSolution";
import HowWeWork from "./components/HowWeWork";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import Pricing from "./components/Pricing";
import VideoTestimonials from "./components/VideoTestimonials";
import Trust from "./components/Trust";
import CTASection from "./components/CTASection";
import Footer from "./components/Footer";
import FloatingActions from "./components/FloatingActions";
import MobileCTABar from "./components/MobileCTABar";
import LeadDialog from "./components/LeadDialog";
import LeadsAdmin from "./pages/LeadsAdmin";

function HomePage() {
  const [leadOpen, setLeadOpen] = useState(false);
  const [leadPlan, setLeadPlan] = useState(null);

  const openLead = (plan) => {
    setLeadPlan(typeof plan === "string" ? plan : null);
    setLeadOpen(true);
  };

  return (
    <div className="bg-white text-slate-900 pb-3 md:pb-0">
      <Header onOpenLead={() => openLead()} />
      <main>
        <Hero onOpenLead={() => openLead()} />
        <Stats />
        <Benefits onOpenLead={() => openLead()} />
        <ProblemSolution />
        <HowWeWork />
        <Services onOpenLead={() => openLead()} />
        <Portfolio />
        <Pricing onOpenLead={openLead} />
        <VideoTestimonials />
        <Trust />
        <CTASection onOpenLead={() => openLead()} />
      </main>
      <Footer />
      <FloatingActions />
      <MobileCTABar onOpenLead={() => openLead()} />
      <LeadDialog open={leadOpen} onClose={() => setLeadOpen(false)} plan={leadPlan} />
    </div>
  );
}

function App() {
  return (
    <LanguageProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/admin/leads" element={<LeadsAdmin />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </LanguageProvider>
  );
}

export default App;
